import { MerchantSetupProductSchema } from "@redotech/redo-onboarding-db-schema";
import * as z from "zod/v4";

export const recordMerchantSetupIntakeStep = {
  name: "recordMerchantSetupIntakeStep" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    setupStepId: z.string().min(1).max(128),
  }),
  output: z.null(),
};
